import '../css/App.css';
import Webpage from './Webpage';
import Header from './Header';

function App() {
  const queryParams = new URLSearchParams(window.location.search)
  const host = queryParams.get('host') || 'ktpl.kpoint.com'; 
  const id = queryParams.get('id'); 
  const hostUrl = queryParams.get('url') || 'https://ktpl.kpoint.com/assets/orca/media/embed/player-silk.js';
  // const videoTitle = queryParams.get('videoTitle') || 'Default Video Title';
  return (
    <div className="App">
      <main>
        <Webpage 
          id={id} 
          host={host}
          hostUrl={hostUrl}
        />
      </main>
    </div>
  );
}


export default App;
